import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { PageStatusResult } from '../pageStatusTypes';
import { getDisplayUrl, getHrefUrl } from '../pageStatusUtils';

type PageStatusResultUrlCellProps = {
  result: PageStatusResult;
};

export const PageStatusResultUrlCell: FC<PageStatusResultUrlCellProps> = ({ result }) => {
  const displayUrl = getDisplayUrl(result);
  const hrefUrl = getHrefUrl(result);

  if (!hrefUrl || !displayUrl) {
    return (
      <Typography variant='body2' color='text.secondary'>
        Mangler URL
      </Typography>
    );
  }

  return (
    <Box
      component='a'
      href={hrefUrl}
      target='_blank'
      rel='noreferrer'
      sx={{
        color: '#1565C0',
        display: 'inline-block',
        maxWidth: '100%',
        overflowWrap: 'anywhere',
        textDecoration: 'underline',
        textUnderlineOffset: 2,
        '&:visited': {
          color: '#6A1B9A',
        },
        '&:hover': {
          color: '#0D47A1',
          textDecoration: 'underline',
        },
      }}>
      {displayUrl}
    </Box>
  );
};
